import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/laboratory/:id',
  title: 'Kit',
  endpoint: '/app/kit',
  breadcrumbs: [],
}
